// extracted by mini-css-extract-plugin
module.exports = {"navs":"Detail_navs__3V6CF","nav":"Detail_nav__3qlFC","act":"Detail_act__3nOtV"};